import type { ComponentType, SVGProps } from "react";

import { cn } from "@ui/lib/utils";

export interface FileIconProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
}

export function FileIcon({ icon: Icon, className }: FileIconProps) {
  return (
    <div
      className={cn("tw-relative tw-w-[60px] tw-h-[79px] tw-shrink-0", className)}
      style={{
        filter:
          "drop-shadow(0 2px 4px rgba(0,0,0,0.04)) drop-shadow(0 1px 1px rgba(0,0,0,0.04)) drop-shadow(0 0 1px rgba(0,0,0,0.40))",
      }}
    >
      <svg viewBox='4 2 60 79' fill='none' className='tw-absolute tw-inset-0 tw-w-full tw-h-full' aria-hidden>
        {/* File body */}
        <path
          d='M54.9651 19.9675C52.9702 19.9656 51.0575 19.1723 49.6469 17.7616C48.2362 16.351 47.4429 14.4383 47.441 12.4433V2H13.8194C11.2151 2 8.71753 3.03453 6.87604 4.87602C5.03455 6.71751 4 9.21512 4 11.8194V71.013C4.00387 73.6147 5.04011 76.1085 6.88118 77.9469C8.72225 79.7852 11.2176 80.8177 13.8194 80.8177H54.1806C56.783 80.8177 59.2789 79.7847 61.1201 77.9456C62.9613 76.1065 63.9971 73.6117 64 71.0093V19.9675H54.9651Z'
          fill='white'
        />
        {/* Corner fold */}
        <path
          transform='translate(47.441 2)'
          d='M16.559 17.9675H7.52417C5.52923 17.9656 3.61654 17.1723 2.20591 15.7616C0.795269 14.351 0.00193215 12.4433 0 10.4433V0L16.559 17.9675Z'
          fill='#EBE8E4'
        />
      </svg>

      {/* Inner icon */}
      <div className='tw-absolute tw-w-7 tw-h-7' style={{ left: 15, top: 28 }}>
        <Icon className='tw-w-full tw-h-full tw-text-[#777169]' />
      </div>
    </div>
  );
}

export default FileIcon;
